import {
  APP_SETTING_UPDATE_LAYOUT_BEGIN,
  APP_SETTING_UPDATE_LAYOUT_SUCCESS,
  APP_SETTING_UPDATE_LAYOUT_FAILURE,
  APP_SETTING_UPDATE_LAYOUT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateLayout(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_UPDATE_LAYOUT_BEGIN,
    });
    const { projectId, version, uuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/layout/${uuid}`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_UPDATE_LAYOUT_SUCCESS,
              data: res.data,
              layoutId: args.uuid,
            });
            toast.success('Updated Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_UPDATE_LAYOUT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_UPDATE_LAYOUT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateLayoutError() {
  return {
    type: APP_SETTING_UPDATE_LAYOUT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_UPDATE_LAYOUT_BEGIN:
      return {
        ...state,
        updateLayoutPending: true,
        updateLayoutError: null,
      };

    case APP_SETTING_UPDATE_LAYOUT_SUCCESS:
      let layouts = state.layouts;
      const objIndex = layouts.findIndex((obj) => obj.uuid == action.layoutId);
      layouts[objIndex] = action.data ? action.data : {};
      return {
        ...state,
        updateLayoutPending: false,
        updateLayoutError: null,
        layouts,
      };

    case APP_SETTING_UPDATE_LAYOUT_FAILURE:
      return {
        ...state,
        updateLayoutPending: false,
        updateLayoutError: action.data.error,
      };

    case APP_SETTING_UPDATE_LAYOUT_DISMISS_ERROR:
      return {
        ...state,
        updateLayoutError: null,
      };

    default:
      return state;
  }
}
